import { Announcement03, Trash03 } from '@untitled-ui/icons-react';

import { Avatar } from '../../../../../../components/avatar';
import { IconButton } from '../../../../../../components/buttons/icon-button';
import { DropdownMenu, DropdownMenuItem } from '../../../../../../components/dropdown-menu';
import { AnimatedDotsIcons } from '../../../../../../components/icons/animatedDotsIcons';
import { tNamespace } from '../../../../../../services/translation';
import { addCommaSeparator } from '../../../../../../shared/number';

const t = tNamespace('app.settings.organization.brands');

export function BrandComponent(props: {
  brandInformation: {
    _id: string;
    name: string;
  };
  isOwner: boolean;
  numberOfContents: number;
  onRemove: () => void;
  onEdit: () => void;
  onCreateContent: () => void;
  isDeletable: boolean;
  canCreateContent?: boolean;
}) {
  const {
    brandInformation,
    numberOfContents,
    onRemove,
    onEdit,
    onCreateContent,
    isDeletable,
    isOwner,
    canCreateContent,
  } = props;

  return (
    <div className="flex items-center gap-4" key={brandInformation._id}>
      <Avatar icon={<Announcement03 width={20} height={20} />} size="md" />
      <div className="flex flex-1 flex-col">
        <p className="font-body-2-m">{brandInformation.name}</p>
        <p className="font-body-2-r text-branding-gray">
          {t('pieceOfContent', { contents: addCommaSeparator(numberOfContents) })}
        </p>
      </div>
      <DropdownMenu
        trigger={
          <IconButton
            isDiv={true}
            size="xs"
            variant="ghost-neutral"
            icon={<AnimatedDotsIcons groupName="group/dots-icon" />}
          />
        }
        triggerClassName="group/dots-icon"
      >
        <DropdownMenuItem label={t('editAttributes')} onClick={onEdit} />
        <DropdownMenuItem
          label={t('createContent')}
          onClick={onCreateContent}
          disabled={!canCreateContent}
        />
        {isDeletable && isOwner ? (
          <DropdownMenuItem
            label={
              <div className="flex items-center gap-2">
                <Trash03 width={16} height={16} className="text-red-500" />
                <p className="text-red-500">{t('deleteBrand')}</p>
              </div>
            }
            onClick={onRemove}
          />
        ) : null}
      </DropdownMenu>
    </div>
  );
}
